import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ajaxCall, ajaxCallReturnValue } from 'src/app/core/services/ajax-call.service';
import { VendorInformation } from '../models/vendor-information.model';
import { DirtyTrackingDirective } from 'src/app/core/dirty-tracking/dirty-tracking.directive';
import { FocusMeDirective } from 'src/app/core/focus-me/focus-me.directive';
import { PDxLists } from 'src/app/core/PDxListItem.model';
import { PDxTransmissionMethod } from 'src/app/core/PDxTransmissionMethod.enum';
import { PDxPOFileType } from 'src/app/core/PDxPOFileType.enum';
import { FileItem, FileUploader } from 'ng2-file-upload';
import { NotifierService } from 'angular-notifier';
import { BlockUIService } from 'ng-block-ui';
import { UploadResult } from 'src/app/core/upload-result.model';

@Component({
  selector: 'app-vendor-properties',
  templateUrl: './vendor-properties.component.html',
  styles: [
  ]
})
export class VendorPropertiesComponent implements OnInit {
  @ViewChild(NgForm) vendorForm!: NgForm;

  @Input() vendorInfo: VendorInformation;
  submitAttempt: boolean = false;
  PDxTransmissionMethods = PDxLists.PDxTransmissionMethods();
  PDxPOFileTypes = PDxLists.PDxPOFileTypes();
  PDxTransmissionMethod = PDxTransmissionMethod;
  PDxPOFileType = PDxPOFileType;
  stateList = PDxLists.AbbreviatedStates();
  public uploader: FileUploader = new FileUploader({ url: '/File/Upload', autoUpload: true });

  constructor(private ajax: ajaxCall,
    private modal: NgbActiveModal,
    private notifier: NotifierService,
    private blockUI: BlockUIService) { }

  ngOnInit(): void {
    this.uploader.onBeforeUploadItem = (item: FileItem) => {
      this.blockUI.start('ajaxCall');
    };

    this.uploader.onCompleteItem = (item: any, response: any, status: any, headers: any) => {
      const file: ajaxCallReturnValue<UploadResult[]> = JSON.parse(response);
      if (file.success) {
        this.vendorInfo.logo = file.results[0];
      } else {
        this.notifier.notify('error', file.message);
      }
      this.blockUI.stop('ajaxCall');
    };
  }

  save(): void {
    this.submitAttempt = true;
    if (this.vendorForm.invalid) {
      return;
    }
    this.ajax.MakeCall<string>('/Vendor/Save', this.vendorInfo).then((vId) => {
      this.modal.close(vId);
    }, () => { });
  }

  dismiss(): void {
    this.modal.dismiss();
  }

  setPOFileType(t: PDxPOFileType) {
    this.vendorInfo.poFileType = t;
  }

  setTransmissionMethod(t: PDxTransmissionMethod) {
    this.vendorInfo.poTransmissionMethod = t;
  }

  removeLogo(): void {
    this.vendorInfo.logo = null;
  }
}
